import React from 'react'
import analytics from '@/shared-utils/analytics'
import BundleHugWithCheckboxes from './BundleHugWithCheckboxes'
import FlightsRecentSearchCard from './FlightsRecentSearchCard'
import { PackageSearchParamsType, FlyRecentSearchData } from '../types'

function fireOnContinueSearchClick() {
  analytics.fireEvent({
    category: 'FLIGHT_HOME',
    action: 'flight recent search',
    label: 'continue search'
  })
}

function fireOnBookABundleClick() {
  analytics.fireEvent({
    category: 'FLIGHT_HOME',
    action: 'flight recent search',
    label: 'checkbox search'
  })
}

function fireOnCheckboxChange(name: string) {
  analytics.fireEvent({
    category: 'FLIGHT_HOME',
    action: 'flight recent search',
    label: `select ${name}`
  })
}

export default function FlightRecentSearchWithCheckbox({
  searchData,
  packageSearchParams
}: {
  searchData: FlyRecentSearchData
  packageSearchParams: PackageSearchParamsType
}) {
  return (
    <FlightsRecentSearchCard
      searchData={searchData}
      onContinueSearchClick={fireOnContinueSearchClick}
    >
      <BundleHugWithCheckboxes
        packageSearchParams={packageSearchParams}
        onBookABundleClick={fireOnBookABundleClick}
        onCheckboxChange={(_selectedOption, selectedOptionName) =>
          fireOnCheckboxChange(selectedOptionName)
        }
      />
    </FlightsRecentSearchCard>
  )
}
